import { registerPlugin } from '@capacitor/core';
const CustomerIO = registerPlugin('CustomerIO', {
    web: () => import('./web').then(m => new m.CustomerIOWeb()),
});
export * from './definitions';
export { CustomerIO };
//# sourceMappingURL=index.js.map